import { CheckCircle } from "lucide-react";

export default function AppSumoPlan() {
  return (
    <div className="w-full mx-auto overflow-x-auto">
      <h2 className="text-xl xs:text-2xl sm:text-3xl font-bold text-center mb-4 sm:mb-6 md:mb-8">
        AppSumo Custom Plan
      </h2>

      <div className="max-w-full overflow-x-auto pb-4">
        <table className="w-full border-collapse min-w-[280px]">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left p-2 xs:p-3 sm:p-4 border border-gray-200 font-medium text-xs sm:text-sm">
                Feature
              </th>
              <th className="text-center p-2 xs:p-3 sm:p-4 border border-gray-200 font-medium text-xs sm:text-sm">
                <div className="text-red-500 font-bold">AppSumo Special</div>
                <div className="text-xs text-gray-500">Annual plan</div>
              </th>
            </tr>
          </thead>
          <tbody>
            <PlanFeatureRow
              title="No. of Campaigns"
              description="Maximum number of campaigns a brand can run in a month"
              value="96"
            />
            <PlanFeatureRow
              title="Collaboration Count"
              description="Total influencer-brand collaborations allowed each month"
              value="540"
            />
            <PlanFeatureRow
              title="Campaign Execution System"
              description="End-to-end tech for campaign execution and tracking"
              included={true}
            />
            <PlanFeatureRow
              title="Real-Time Performance Tracking"
              description="Monitor live campaign performance metrics in real-time"
              included={true}
            />
            <PlanFeatureRow
              title="Audience Reach Analysis"
              description="Insights into the demographics of who saw the campaign"
              value="540"
            />
            <PlanFeatureRow
              title="Audience Engagement Analysis"
              description="AI-analyzed data on who engaged with the campaign"
              value="540"
            />
            <PlanFeatureRow
              title="Brand Sentiment Insights"
              description="Analysis of competitor mentions, comment themes, and audience sentiment"
              value="540"
            />
            <PlanFeatureRow
              title="Campaign Overview Report"
              description="Summary of the campaign's overall performance across influencers"
              value="96"
            />
            <PlanFeatureRow
              title="Campaign Report Delivery"
              description="Campaign reports emailed directly to your inbox"
              included={true}
            />
            <PlanFeatureRow
              title="Detailed Influencer Insights"
              description="Comprehensive data on influencers, including past campaigns and audience fit"
              value="4800"
            />
            <PlanFeatureRow
              title="AI-Powered Recommendations"
              description="Smart influencer suggestions based on your preferences and filters"
              included={true}
            />
            <PlanFeatureRow
              title="Advanced Search Filters"
              description="Use detailed filters like Top Voice Badges, College Tier & more"
              included={true}
            />
            <PlanFeatureRow
              title="Manual Filtering"
              description="Customize filters to search for influencers that fit your needs"
              included={true}
            />
            <PlanFeatureRow
              title="Team Accounts"
              description="Number of users who can access your brand account"
              value="1"
            />
            <PlanFeatureRow
              title="WhatsApp Alerts"
              description="Instant campaign updates and notifications on WhatsApp"
              included={true}
            />
            <PlanFeatureRow
              title="Email Notifications"
              description="Alerts and updates delivered via email"
              included={true}
            />
            <PlanFeatureRow
              title="Data Refresh Requests"
              description="Number of times a brand can request influencers to update their stats"
              value="1200"
            />
            <PlanFeatureRow
              title="Campaign Calendar View"
              description="Visualize live and scheduled campaigns on a calendar"
              included={true}
            />
            <PlanFeatureRow
              title="Custom Campaign Scheduling"
              description="Set unique live dates for each influencer in your campaign"
              included={true}
            />

            {/* Add-Ons Section */}
            <tr className="border-b border-gray-200 bg-gray-50">
              <td
                colSpan={2}
                className="p-2 xs:p-3 sm:p-4 border-x border-gray-200 text-center font-bold text-xs sm:text-sm"
              >
                Add-Ons
              </td>
            </tr>

            <PlanFeatureRow
              title="Additional Campaign"
              description="Add more campaigns to your monthly plan for extended reach and visibility"
              value="$24"
            />
            <PlanFeatureRow
              title="Extra Collaboration*"
              description="Increase the number of influencer-brand interactions for your campaigns"
              value="$10"
            />
            <PlanFeatureRow
              title="Additional Team Account"
              description="Add more team members to your account with full platform access"
              value="$47"
            />
          </tbody>
        </table>
      </div>

      <div className="mt-4 text-center text-xs text-gray-500">
        * Includes individual reports, engagement analysis, and integration into
        the overall campaign insights
      </div>
    </div>
  );
}

function PlanFeatureRow({
  title,
  description,
  value,
  included,
}: {
  title: string;
  description: string;
  value?: string;
  included?: boolean;
}) {
  return (
    <tr className="border-b border-gray-200 hover:bg-gray-50">
      <td className="p-2 xs:p-3 sm:p-4 text-left border-x border-gray-200">
        <div className="font-medium text-xs sm:text-sm">{title}</div>
        <div className="text-gray-500 text-xs">{description}</div>
      </td>
      <td className="p-2 xs:p-3 sm:p-4 border-x border-gray-200 text-center">
        {value ? (
          <div className="font-medium text-xs sm:text-sm">{value}</div>
        ) : included ? (
          <CheckCircle className="h-4 w-4 sm:h-5 sm:w-5 text-green-500 mx-auto" />
        ) : (
          <div>-</div>
        )}
      </td>
    </tr>
  );
}
